import React from "react";
import InputComponent from "../../common/input/input";
import ButtonComponent from "../../common/button/button";

import "./GeneralSettings.scss";

function GeneralSettings({ userInfo }) {
  return (
    <>
      <div className="profile-form-container">
        <ul className="form-list">
          <li>
            <label>First Name</label>
            <span>{userInfo.first_name}</span>
          </li>
          <li>
            <label>Last Name</label>
            <span>{userInfo.last_name}</span>
          </li>
          <li>
            <label>Designation</label>
            <span>{userInfo.designation}</span>
          </li>
          <li>
            <label>Email</label>
            <span>{userInfo.user_email}</span>
          </li>
          <li>
            <label>Phone</label>
            <span>{userInfo.phone}</span>
          </li>
          <li>
            <label>Role</label>
            <span>{userInfo.role}</span>
          </li>
        </ul>
      </div>
    </>
  );
}

export default GeneralSettings;
